export const cifDk = ["301 227","<g fill-rule='nonzero' fill='none'><path fill='#C60C30' d='M.5.5h300v226H.5z'/><path fill='#FFF' d='M96.791.5h32.354v226H96.791z'/><path fill='#FFF' d='M300.5 97.323v32.354H.5V97.323z'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-dk.js
// module id = null
// module chunks = 